import CRUDReducer from '../CRUDReducer';
import tagsAction from '../../actions/fan_feed/fan_feed_tags';

const tagsCRUDReducer = new CRUDReducer(tagsAction);

export default (state, action) => tagsCRUDReducer.run(state, action);


// WEBPACK FOOTER //
// ./src/reducers/fan_feed/fan_feed_tags.ts